<script lang="ts" setup>
import { request } from "@/services/request";

const config = useRuntimeConfig();
const onboardingStore = useOnboardingStore();

const errorMessage = ref("Something went wrong. Please try again.");
const email = ref("");
const emailError = ref(false);
const showSuccessMessage = ref(false);
const showErrorMessage = ref(false);

const currentApiSubscribe = computed(
  () => `${config.public.baseApiEnpoint}/api/marketing/blog-subscriptions`
);

const submitForm = () => {
  showSuccessMessage.value = false;
  showErrorMessage.value = false;

  if (!validateEmail(email.value)) {
    emailError.value = true;
    showSuccessMessage.value = false;
    return;
  }
  emailError.value = false;

  const formData = {
    email: email.value,
    pageUrl: window.location.href,
    abandonedCartId: onboardingStore.abandonedCartId,
  };

  request
    .post(currentApiSubscribe.value, formData)
    .then(() => {
      showSuccessMessage.value = true;
      email.value = "";
    })
    .catch((error) => {
      console.error("There was a problem with your submission:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        console.log("Error message from server:", error.response.data.message);
        errorMessage.value = error.response.data.message;
      }
      showErrorMessage.value = true;
      showSuccessMessage.value = false;
    });
};
</script>

<template>
  <div>
    <h3
      class="tw-hidden sm:tw-block tw-font-bold tw-font-agendaCond tw-text-[14px] tw-tracking-[0.04em] tw-mb-2.5"
    >
      Stay updated:
    </h3>
    <form
      id="form-newsletter"
      class="subscribe-form tw-w-full"
      novalidate="true"
      @submit.prevent="submitForm"
    >
      <div class="input-wrap w-full">
        <input
          id="email-inputter"
          v-model="email"
          placeholder="Enter your email"
          name="email"
          required
          type="email"
          class="tw-h-10 tw-w-full tw-rounded-[7px] tw-px-4 tw-text-base tw-nl-green-100 placeholder:tw-text-nl-green-100/50 tw-shadow-nl-6 focus:tw-outline focus:tw-outline-1 focus:tw-outline-blue"
          :class="{ 'tw-border-red-500 tw-border-2 error': emailError }"
        />
      </div>
      <button
        type="submit"
        class="btn tw-min-w-0 tw-w-full tw-mt-1.5 tw-flex tw-justify-center tw-items-center focus:tw-bg-nl-violet-200 tw-text-[16px] tw-p-2 tw-min-h-[45px] hover:tw-bg-nl-violet-200 tw-font-bold md:tw-font-semibold md:tw-py-[11px] tw-bg-nl-violet-100"
      >
        Subscribe
      </button>
      <p v-if="showSuccessMessage" class="text-center text-green-100 mt-10">
        Thank you for subscribing!
      </p>
      <p
        v-if="showErrorMessage"
        class="error-message text-center mt-10 text-red-100"
      >
        {{ errorMessage }}
      </p>
    </form>
  </div>
</template>
